
<div class="row border rounded m-1 p-1">
    <div class="row row-cols-lg-auto gx-2">
        <div class="col-12">
            <select name="viewType" class="form-select form-select-sm" [(ngModel)]="stagingType">
                <option [ngValue]="0">Open Contracts</option>
                <option [ngValue]="1">Default Schedules</option>
            </select>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" style="width: 130px;" (click)="createSchedules()" *ngIf="!creatingSchedules">Create Schedules</button>
            <button type="button" class="btn btn-sm btn-primary me-2" style="width: 130px;" disabled *ngIf="creatingSchedules">
                <span class="spinner-border spinner-border-sm me-1"></span>
                <span>Processing...</span>
            </button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" style="width: 180px;" [disabled]="scheduleParameters.stagingType == 1" (click)="addDefaultSchedules()" *ngIf="!addingDefaultSchedule">Add To Default Schedules</button>
            <button type="button" class="btn btn-sm btn-primary me-2" style="width: 180px;" disabled *ngIf="addingDefaultSchedule">
                <span class="spinner-border spinner-border-sm me-1"></span>
                <span>Processing...</span>
            </button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="clearFilters()">Clear Filters</button>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="clearSorting()">Default Sort</button>
        </div>
        <div class="col-12 text-danger ms-3 pt-1">
            {{statusMessage}}
        </div>
    </div>
</div>
<div class="m-1">
    <pqgrid #stagingGrid [options]="stagingOptions"></pqgrid>
</div>

<staging-contracts [contractParameters]="contractParameters"></staging-contracts>


<delete-confirm #childComponent [deleteItemParameters]="deleteItemParams" [deleteFormId]="'scheduleStagingDeleteModal'" (confirmEmitter)="deleteItem($event, deleteItemParams)"></delete-confirm>